var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('img',{attrs:{"src":require("@/assets/image/暂无数据1@2x.png"),"alt":""}}),_c('p',[_vm._v("暂无项目数据")])])
}]

export { render, staticRenderFns }